import React from 'react';
import PropTypes from 'prop-types';
import AppsBanner from '../../components/AppsBanner';
import Categories from '../../components/Categories';
import RecommendedRow from '../../components/RecommendedRow';
import fireBatchedImpressions from '../../lib/BatchImpressions';
import StaffPicks from '../../components/StaffPicks';
import IntentRow from '../../components/IntentRow';
import SurveyButton from '../../components/SurveyButton';
import GetStarted from '../../components/GetStarted';
import QuickLinks from '../../components/QuickLinks';

class Main extends React.Component {
  componentDidMount = () => {
    const links = this.getImpressionLinks();
    const { toolTileProps: { app: { csrf = '' } = {} } = {} } = this.props;
    fireBatchedImpressions(links, csrf);
  };

  getImpressionLinks = () => {
    const links = [];
    const {
      structuredPSData: {
        content: { PSImpressionUrl = '' },
        categories = []
      } = {}
    } = this.props;
    links.push(PSImpressionUrl);
    categories.forEach(({ content = {}, featured = [] }) => {
      links.push(content.PSImpressionUrl);
      featured.forEach(({ PSImpressionUrl = '' }) => {
        links.push(PSImpressionUrl);
      });
    });
    return links;
  };

  renderYourRecommendations = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      defaultRecommended = []
    } = this.props;
    const { flatPSData: { recommended = [] } = {} } = toolTileProps;
    return (
      <div id="appcenter-categories">
        <RecommendedRow
          content={recommended[0]}
          featured={defaultRecommended}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      </div>
    );
  };

  renderIntentTools = () => {
    const {
      fptiClick,
      experimentation = {},
      fptiImpression,
      toolTileProps,
      structuredPSData = {}
    } = this.props;
    const { flatPSData: { intentRow = [] } = {} } = toolTileProps;
    const { intentToolsDisplayed = [] } = structuredPSData;
    return !intentToolsDisplayed.length || !experimentation.intentExp ? null : (
      <IntentRow
        fptiImpression={fptiImpression}
        fptiClick={fptiClick}
        toolTileProps={toolTileProps}
        content={intentRow[0]}
        structuredPSData={structuredPSData}
        {...this.props}
      />
    );
  };

  renderStaffPicks = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      structuredPSData,
      experimentation = {}
    } = this.props;
    const { flatPSData: { staffPick = [] } = {} } = toolTileProps;
    const { staffPickDisplayed = [] } = structuredPSData;

    if (
      !staffPickDisplayed.length ||
      !experimentation.staffPickExp ||
      !staffPick[0] ||
      !staffPick[0].categoryTitle
    ) {
      return null;
    }

    return (
      <StaffPicks
        fptiImpression={fptiImpression}
        fptiClick={fptiClick}
        content={staffPick[0]}
        toolTileProps={toolTileProps}
        {...this.props}
      />
    );
  };

  renderGetStarted = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps: {
        flatPSData: {
          getStarted = [],
          tools = {},
          categories = {},
          intentMessages = []
        } = {}
      } = {}
    } = this.props;
    return (
      <GetStarted
        fptiClick={fptiClick}
        fptiImpression={fptiImpression}
        content={getStarted[0]}
        appIntents={intentMessages}
        tools={tools}
        categories={categories}
        toolTileProps={this.props.toolTileProps}
      />
    );
  };

  render() {
    const {
      structuredPSData: { content = {}, categories = [] } = {},
      fptiClick,
      fptiImpression,
      quicklinks,
      toolTileProps: {
        app: {
          context: { user: { isLoggedIn } = {} } = {},
          deviceInfo: { isDesktop } = {}
        } = {},
        flatPSData: { isRecommendedCategoryEligible, isMerchantActivated } = {}
      } = {},
      experimentation: { moduleFederation, getStartedExp } = {}
    } = this.props;

    const shouldShowGetStartedRec = !isMerchantActivated && !!getStartedExp;

    return (
      <div id="appcenter-main">
        <AppsBanner content={content} />
        {isLoggedIn && shouldShowGetStartedRec && this.renderGetStarted()}
        {isLoggedIn &&
          isRecommendedCategoryEligible &&
          !shouldShowGetStartedRec &&
          this.renderYourRecommendations()}
        {isLoggedIn && !shouldShowGetStartedRec && this.renderStaffPicks()}
        {!isLoggedIn && this.renderIntentTools()}
        {isDesktop && !shouldShowGetStartedRec && (
          <QuickLinks
            moduleFederation={moduleFederation}
            quicklinks={quicklinks}
            isLoggedIn={isLoggedIn}
            isDesktop={isDesktop}
          />
        )}
        <Categories
          categories={categories}
          viewAllText={content.viewDetails}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={this.props.toolTileProps}
        />
        <SurveyButton
          fptiClick={fptiClick}
          toolTileProps={this.props.toolTileProps}
          content={content}
        />
      </div>
    );
  }
}

Main.displayName = 'main';

Main.propTypes = {
  categories: PropTypes.array,
  ps: PropTypes.object,
  structuredPSData: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  defaultRecommended: PropTypes.array,
  experimentation: PropTypes.object,
  quicklinks: PropTypes.object
};

export default Main;
